import image1 from '@/assets/images/news/detail/20200421/1.jpg';
import image2 from '@/assets/images/news/detail/20200421/2.jpg';
import image3 from '@/assets/images/news/detail/20200421/3.jpg';
import image4 from '@/assets/images/news/detail/20200421/4.jpg';
import image5 from '@/assets/images/news/detail/20200421/5.jpg';
import image6 from '@/assets/images/news/detail/20200421/6.jpg';

export default {
  id: '20200421', //  模块 id
  title: '雄关漫道真如铁 而今迈步从头越', // 标题
  content: [
    // {
    //   type: 0, // 数据类型 0-普通文本 1-图片
    //   text: '2020年4月21日，这个必将载入叮咚史册的日子：北京我们来了！', // 文本内容
    //   isIndent: false, // 是否首行缩进 true-首行缩进 false-不缩进
    // },
    // {
    //   type: 1,
    //   title: '图片下方标题', // 图片下方标题
    //   src: [
    //     'kkk' // 图片地址
    //   ],
    // },

    {
      type: 0,
      text: '2020年4月21日，这个必将载入叮咚史册的日子：北京我们来了！',
      isIndent: false,
    },
    {
      type: 0,
      text:
        '为了迎接这个特别的时刻，北京事业部办公室、前置仓、北京城市分选中心分别举行了开业庆祝仪式。虽然今年受疫情影响，简化了开业仪式的流程，但是阻挡不了小伙伴们高涨的热情。北京的行政小姐姐为大家精心准备的开业蛋糕和茶歇，每一份都是小姐姐们的贴心关怀，在这里我们要道一声：辛苦了！',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text:
        '在位于朝阳的总部办公室里，北京事业部，北京招聘团队、采销团队以及从上海来京支援的小伙伴们聚集在一起，由业绩生长中心的沈方老师，带领大家举行了简单的庆祝仪式。今天是北京事业部诞生的日子，也是北京事业部迎接大考的日子，一切的努力且看今朝表现。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text:
        '在第一批开业的前置仓内，呈现在我们眼前的，是每一位穿梭忙碌的分拣员、水产员、配送员、拉新专员。比起庆祝开业的喜悦心情，大家更关心的是如何把生鲜更好的送到每一位北京用户的手里，给新用户留下一个良好的第一印象，部分前置仓选择在完成一天忙碌工作后，品尝胜利的果实。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3, image4],
    },
    {
      type: 0,
      text:
        '在位于北京顺义和大兴的大仓内，为了仓库建设付出了许多努力的大仓小伙伴们，大家一起团聚在一起，分享美味的蛋糕，见证属于北京城市分选中心的重要时刻。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5, image6],
    },
    {
      type: 0,
      text:
        '无论过去的日子多艰难，现在的叮咚准时站在了时间的轴线上，不断创造奇迹：',
      isIndent: false,
    },
    {
      type: 0,
      text: '11:28 破1000单',
      isIndent: false,
    },
    {
      type: 0,
      text: '13:17 破2000单',
      isIndent: false,
    },
    {
      type: 0,
      text: '15:34 破3000单',
      isIndent: false,
    },
    {
      type: 0,
      text: '16:56 破4000单',
      isIndent: false,
    },
    {
      type: 0,
      text: '18:28 破5000单',
      isIndent: false,
    },
    {
      type: 0,
      text: '...',
      isIndent: false,
    },
    {
      type: 0,
      text: '无论未来的道路多坎坷，叮咚人仍然坚守岗位，重服务！守品质！保民生!',
      isIndent: false,
    },
    {
      type: 0,
      text: '感恩叮咚拥有最棒的你们！',
      isIndent: false,
    },
  ],
};
